import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'styles/media';
import classnames from 'classnames';

const MenuLink = styled.a``;

const Li = styled.li``;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;

  &.inline {
    flex-direction: row;
  }

  ${media.medium`
    display: none
  `}
`;

/**
 * Placeholder for the real menu
 *
 * @param {array} menuItem - array of objects
 * @param {boolean} inline - boolean to determine how menu looks
 * @param {string} className
 */

const MenuList = ({ menuItems = [], inline, className }) => {
  const classes = classnames({ inline, [className]: !!className });

  return (
    <Ul className={classes}>
      {menuItems.map(menuItem => {
        return (
          <Li key={menuItem.label}>
            <MenuLink href={menuItem.path} target={menuItem.target}>
              {menuItem.label}
            </MenuLink>
          </Li>
        );
      })}
    </Ul>
  );
};

MenuList.propTypes = {
  menuItems: PropTypes.array,
  inline: PropTypes.bool,
  className: PropTypes.string,
};

export default MenuList;
